{
  "id": "campaign-092",
  "name": "Moonlit Grounds",
  "seed": "campaign:92",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "x...L__L..~.",
    ".....__..~~.",
    "....i__i..~.",
    ".i.i.__.i.i.",
    ".,...__.....",
    ",.,.#__X....",
    ".i.i.__.i.i.",
    ".....__,....",
    ".....__,,...",
    ".i.i.__,i.i.",
    ".*..i__i..*.",
    ".....__.....",
    ".i.i.__.i.i.",
    "....%__.....",
    "..#..__..%%.",
    "...X.....%..",
    "X....X.....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 15
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 0
    },
    {
      "kind": "rare",
      "x": 6,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 92,
  "biome": "cemetery",
  "par": {
    "reel": 6397,
    "push": 5587,
    "selfPropelled": 5226,
    "tractor": 4545,
    "zeroTurn": 3359,
    "fairway": 2334
  },
  "routeTries": {
    "par": {
      "reel": 15,
      "push": 17,
      "selfPropelled": 5,
      "tractor": 21,
      "zeroTurn": 24,
      "fairway": 19
    }
  }
}
